import '@greensm/ui/styles.css';
import '@greensm/map/map.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import './app/app.css';

import { configureGoongMaptilesKey } from '../../../packages/map/src/goongConfig';
import { configureTileSources, tileSourcesFromConfig } from '../../../packages/map/src/tileSources';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { env, isMock } from './app/config/env';
import { Providers } from './app/providers';
import { AppRoutes } from './app/router';
import { createServices } from './app/services';

async function bootstrap() {
  configureGoongMaptilesKey(env.goongMaptilesKey);
  configureTileSources(tileSourcesFromConfig(env.mapTiles));
  let fetchImpl: typeof fetch | undefined;
  let v3FetchImpl: typeof fetch | undefined;
  let devPanel: React.ReactNode = null;

  if (isMock) {
    // Mã giả lập chỉ được nạp khi VITE_API_MODE=mock – không lọt vào bản chạy thật.
    const { createMockBackend } = await import('./mocks/mockBackend');
    const { createMockBackendV3 } = await import('./mocks/v3/mockBackendV3');
    const { DevPanel } = await import('./mocks/DevPanel');
    const backend = createMockBackend({ delayMs: 350, autoProgress: true, persistKey: 'gsm.mock.state' });
    fetchImpl = backend.fetch;
    const backendV3 = createMockBackendV3({
      liveDriverMs: 3000, // xe tự gửi GPS như Backend thật
      autoDispatchMs: 5000, // đặt xe xong ~5 s thì tài xế A nhận chuyến (C3 → C4)
      scenarios: { cus1: 'G3_START' }, // G3 bước 1: cus1 chưa có chuyến, đặt xe qua trợ lý
    });
    v3FetchImpl = backendV3.fetch;
    (window as unknown as { gsmMockV3?: unknown }).gsmMockV3 = backendV3.controls; // điều khiển kịch bản v3 từ console khi demo
    // Bảng điều khiển người trình bày: ẩn mặc định; mở bằng ?dev=1 (nhớ trong phiên), tắt bằng ?dev=0.
    const q = new URLSearchParams(location.search).get('dev');
    try { if (q === '1') sessionStorage.setItem('gsm.dev', '1'); if (q === '0') sessionStorage.removeItem('gsm.dev'); } catch { /* bỏ qua */ }
    let show = import.meta.env.DEV || q === '1';
    try { show ||= sessionStorage.getItem('gsm.dev') === '1'; } catch { /* bỏ qua */ }
    if (show) devPanel = <DevPanel controls={backend.controls} />;
  }

  const services = createServices({ baseUrl: env.apiBaseUrl, fetchImpl,
    apiMode: isMock ? 'mock' : 'live', devUsername: env.devUsername,
    v3BaseUrl: env.apiV3BaseUrl, v3FetchImpl });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Providers services={services}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        {devPanel}
      </Providers>
    </StrictMode>,
  );

  if ('serviceWorker' in navigator) {
    if (isMock) {
      // Bản demo: KHÔNG dùng service worker và xoá mọi bản đã đăng ký/cache trước đó ⇒ không bao giờ kẹt ở bản cũ hoặc ảnh vỡ.
      void navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => void r.unregister()));
      if ('caches' in window) void caches.keys().then((ks) => ks.forEach((k) => void caches.delete(k)));
    } else if (import.meta.env.PROD) {
      window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js'); });
    }
  }
}

void bootstrap();
